import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { T } from '../../../../../../common/locale/translate';

export default class ProvidersSelect extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentProviderName: this.prepareDefaultProviderName(),
      currentProviderCode: this.props.defaultProviderCode,
      title: '',
      active: false
    };
    this.renderOptions = this.renderOptions.bind(this);
    this.handleOptionClick = this.handleOptionClick.bind(this);

    this.handleClose = this.handleClose.bind(this);
    this.handleFocus = this.handleFocus.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);

    this.prepareDefaultProviderName = this.prepareDefaultProviderName.bind(
      this
    );
  }

  componentDidMount() {
    document.addEventListener(
      'click',
      this.handleClickOutside.bind(this),
      true
    );
  }

  componentWillUnmount() {
    document.removeEventListener(
      'click',
      this.handleClickOutside.bind(this),
      true
    );
  }

  render() {
    const options = this.renderOptions();

    return (
      <div
        className={
          'providers-select select-wrapper animated-text-form ' +
          (this.state.active ? 'active' : '')
        }
      >
        <label className="animated-text-label">
          <span className="animated-text-label-name">{this.state.title}</span>
        </label>
        <i className="dropdown-icon fa fa-chevron-down" />
        <input
          type="text"
          value={this.state.currentProviderName}
          className="animated-text-input"
          placeholder=""
          onChange={this.handleChange}
          onFocus={this.handleFocus}
          readOnly
        />
        <ul className="dropdown-menu">{options}</ul>
      </div>
    );
  }

  renderOptions = () => {
    let that = this;
    let providers = this.props.providers;
    providers.sort((a, b) => {
      return a.name < b.name ? -1 : 1;
    });

    return providers.map(function(provider, i) {
      const isChecked = provider.code === that.state.currentProviderCode;
      return (
        <li key={`provider-${provider.id}-${i}`} className="item">
          <input
            type="radio"
            id={`provider-${provider.code}`}
            onChange={that.handleOptionClick}
            data-code={provider.code}
            data-name={provider.name}
            checked={isChecked}
          />
          <label htmlFor={`provider-${provider.code}`}> {provider.name} </label>
        </li>
      );
    });
  };

  handleOptionClick = event => {
    let selectedProviderCode = event.currentTarget.dataset.code;
    let selectedProviderName = event.currentTarget.dataset.name;

    this.props.handleChange(selectedProviderCode);
    this.setState({
      currentProviderCode: selectedProviderCode,
      currentProviderName: selectedProviderName,
      active: false
    });
  };

  handleClickOutside = event => {
    const domNode = ReactDOM.findDOMNode(this);
    if (!domNode || !domNode.contains(event.target)) {
      this.handleClose();
    }
  };

  handleClose = () => this.setState({ active: false });

  handleFocus = () => this.setState({ active: true });

  prepareDefaultProviderName() {
    const providers = this.props.providers;
    const defaultProviderCode = this.props.defaultProviderCode;
    let defaultName = T('choose_operator');

    providers.map(provider => {
      if (provider.code == defaultProviderCode) {
        defaultName = provider.name;
      }
    });
    return defaultName;
  }
}



// WEBPACK FOOTER //
// ./app/javascript/pages/offer/components/descriptions/providers_select.jsx